import * as ImagesConnection from 'connections/images';

export const upload = (file, folder, user) => {
  return ImagesConnection.upload(file, folder, user);
};
